import BankLetter from "static/images/document_types/bank_letter.png";
import BankStatement from "static/images/document_types/bank_statement.png";
import PhotoIdentification from "static/images/document_types/photo_identification.png";
import PreviousProcessorStatements from "static/images/document_types/previous_processor_statements.png";
import BusinessLicense from "static/images/document_types/business_license.png";
import UtilityBill from "static/images/document_types/utility_bill.png";
import ApplicationUnredacted from "static/images/document_types/application_unredacted.png";
import OtherUnderwritingDocument from "static/images/document_types/other_underwriting_documents.png";
import OtherDocument from "static/images/document_types/other_document.svg";
import TaxReturn from "static/images/document_types/tax_return.png";
import VoidedCheck from "static/images/document_types/voided_check.png";
import EquipmentOrderingForm from "static/images/document_types/other_underwriting_documents.png"; //TODO:change icon
import UnderwritingDocument from "static/images/document_types/sensitive.png";
import AgentContract from "static/images/document_types/agentContract.svg";
import ResidualSplitProfileEmail from "static/images/document_types/residualSplitProfileEmail.svg";
import SignedScheduleA from "static/images/document_types/signedScheduleA.svg";

export const TransactionFeeTypeByValue = (
	transactionFeeTypeByValue,
	getEnumName = false,
) => {
	switch (+transactionFeeTypeByValue) {
		case 0:
			return getEnumName ? "InterchangePlus" : "Interchange Plus";
		case 1:
			return getEnumName ? "FlatRate" : "Flat Rate";
		case 2:
			return getEnumName ? "ThreeTier" : "Three Tier";
		case 3:
			return "ERR";
		default:
			return "Invalid";
	}
};

export const ChooseValue = chooseThreeValue => {
	switch (+chooseThreeValue) {
		case 0:
			return "Wireless Fee";
		case 1:
			return "Statement Fee";
		case 2:
			return "Online Access/Reporting Fee";
		case 3:
			return "Software Fee";
		case 4:
			return "Equipment Fee";
		case 5:
			return "Other Fee";
		case 6:
			return "None";
		default:
			return "Invalid";
	}
};

export const TypeOfBusinessByValue = (
	typeOfBusinessByValue,
	getEnumName = false,
) => {
	switch (+typeOfBusinessByValue) {
		case 0:
			return getEnumName ? "SoleProp" : "Sole Proprietor";
		case 1:
			return getEnumName ? "LLC" : "Limited Liability Company";
		case 2:
			return getEnumName ? "Corp" : "Corporation";
		case 3:
			return "Partnership";
		case 4:
			return getEnumName ? "TrustEstate" : "Trust/Estate";
		case 5:
			return getEnumName ? "TaxExtemp501c" : "Tax Exempt 501 (c)(3)";
		case 6:
			return "Other";
		default:
			return "Invalid";
	}
};

export const LocationTypeByValue = (
	locationTypeByValue,
	getEnumName = false,
) => {
	switch (+locationTypeByValue) {
		case 0:
			return "Home";
		// case 1: // Removed from the Front End, but present in the enum at the Back End
		// 	return "Apartment";
		case 2:
			return getEnumName ? "StoreFront" : "Store Front";
		case 3:
			return "Other";
		case 4:
			return "Office";
		default:
			return "Invalid";
	}
};

export const PackageTypeByValue = packageType => {
	switch (+packageType) {
		case 0:
			return "None";
		case 1:
			return "Bronze";
		case 2:
			return "Silver";
		case 3:
			return "Gold";
		default:
			return "Invalid";
	}
};

export const RefundPolicyByValue = (
	refundPolicyByValue,
	getEnumName = false,
) => {
	switch (+refundPolicyByValue) {
		case 0:
			return getEnumName ? "RefundWithin30Days" : "Refund Within 30 Days";
		case 1:
			return getEnumName ? "ExchangeOnly" : "Exchange Only";
		case 2:
			return "Other";
		case 3:
			return "None";
		default:
			return "Invalid";
	}
};

export const AttachmentDocumentName = documentName => {
	switch (+documentName) {
		case 0:
			return "Bank Letter";
		case 1:
			return "Photo Identification";
		case 2:
			return "Tax Return";
		case 3:
			return "Bank Statement";
		case 4:
			return "Voided Check";
		case 5:
			return "Business License";
		case 6:
			return "Utility Bill";
		case 7:
			return "Previous Processor Statements";
		case 8:
			return "Application (Unredacted)";
		case 9:
			return "Other Underwriting Documentation";
		case 10:
			return "Equipment Ordering Form";
		case 11:
			return "Underwriting Document";
		case 12:
			return "Agent Contract";
		case 13:
			return "Signed Schedule A";
		case 14:
			return "Residual Split Profile Email";
		case 15:
			return "Other";
		default:
			return "Unknown";
	}
};

export const GetAttachmentImagePath = type => {
	switch (+type) {
		case 0:
			return BankLetter;
		case 1:
			return PhotoIdentification;
		case 2:
			return TaxReturn;
		case 3:
			return BankStatement;
		case 4:
			return VoidedCheck;
		case 5:
			return BusinessLicense;
		case 6:
			return UtilityBill;
		case 7:
			return PreviousProcessorStatements;
		case 8:
			return ApplicationUnredacted;
		case 9:
			return OtherUnderwritingDocument;
		case 10:
			return EquipmentOrderingForm;
		case 11:
			return UnderwritingDocument;
		case 12:
			return AgentContract;
		case 13:
			return SignedScheduleA;
		case 14:
			return ResidualSplitProfileEmail;
		case 15:
			return OtherDocument;
		default:
			return undefined;
	}
};

export const CreditDebitByValueTypeCart = (
	creditDebitByValueTypeCart,
	getEnumName = false,
) => {
	creditDebitByValueTypeCart = +creditDebitByValueTypeCart;
	switch (creditDebitByValueTypeCart) {
		case 0:
			return getEnumName ? "DateOfOrder" : "Date of Order";
		case 1:
			return getEnumName ? "DateOfShipment" : "Date of Shipment";
		case 2:
			return "Other";
		default:
			return "Invalid";
	}
};

export const TerminalTypeByValue = (
	terminalTypeByValue,
	getEnumName = false,
) => {
	switch (+terminalTypeByValue) {
		case 0:
			return "None";
		case 1:
			return "Purchase";
		case 2:
			return getEnumName ? "RentToOwn" : "Rent to Own";
		case 3:
			return "Rental";
		case 4:
			return "Reprogram";
		case 5:
			return getEnumName ? "FreePlacement" : "Free Placement";
		case 6:
			return "Loaner";
		case 7:
			return getEnumName ? "WarrantyProgram" : "Warranty Program";
		default:
			return "Invalid";
	}
};

export const TerminalInstallByValue = (
	terminalInstallByValue,
	getEnumName = false,
) => {
	switch (+terminalInstallByValue) {
		case 0:
			return "None";
		case 1:
			return getEnumName ? "AuroraInstall" : "Aurora Install";
		case 2:
			return getEnumName ? "AgentInstall" : "Agent Install";
		default:
			return "Invalid";
	}
};

export const PinDebitByValue = pinDebitByValue => {
	switch (+pinDebitByValue) {
		case 0:
			return "Internal";
		case 1:
			return "External";
		case 2:
			return "None";
		default:
			return "Invalid";
	}
};

export const OrderNumberTypeByValue = orderNumberTypeByValue => {
	switch (+orderNumberTypeByValue) {
		case 0:
			return "None";
		case 1:
			return "Restaurant";
		case 2:
			return "Retail";
		default:
			return "Invalid";
	}
};

export const ConnectionPrimaryByValue = connectionPrimaryByValue => {
	switch (+connectionPrimaryByValue) {
		case 0:
			return "None";
		case 1:
			return "LTE3G";
		case 2:
			return "WiFi";
		case 3:
			return "Ethernet";
		case 4:
			return "DialUp";
		default:
			return "Invalid";
	}
};

export const ConnectionBackupByValue = connectionBackupByValue => {
	switch (+connectionBackupByValue) {
		case 0:
			return "None";
		case 1:
			return "LTE3G";
		case 2:
			return "WiFi";
		case 3:
			return "Ethernet";
		case 4:
			return "DialUp";
		default:
			return "Invalid";
	}
};

export const ShippingPaymentByValue = (
	shippingPaymentByValue,
	getEnumName = false,
) => {
	switch (+shippingPaymentByValue) {
		case 0:
			return "None";
		case 1:
			return getEnumName ? "ach" : "ACH";
		case 2:
			return getEnumName ? "CreditCard" : "Credit Card";
		default:
			return "Invalid";
	}
};

export const BillToTypeByValue = billToTypeByValue => {
	switch (+billToTypeByValue) {
		case 0:
			return "None";
		case 1:
			return "Merchant";
		case 2:
			return "Agent";
		case 3:
			return "Aurora";
		default:
			return "Invalid";
	}
};

export const ShippingByValue = (shippingByValue, getEnumName = false) => {
	switch (shippingByValue) {
		case 0:
			return "None";
		case 1:
			return "Ground";
		case 2:
			return getEnumName ? "TwoDay" : "Two Day";
		case 3:
			return "Overnight";
		default:
			return "Invalid";
	}
};

export const PointTypeByValue = (pointType, getEnumName = false) => {
	switch (+pointType) {
		case 0:
			return "None";
		case 1:
			return getEnumName ? "FirstData" : "First Data";
		case 2:
			return "TSYS";
		default:
			return undefined;
	}
};

export const FrontEndPlatformByValue = (
	frontEndPlatformValue,
	getEnumName = false,
) => {
	switch (+frontEndPlatformValue) {
		case 0:
			return "None";
		case 1:
			return "Omaha";
		case 2:
			return "Nashville";
		case 3:
			return "North";
		case 4:
			return "Compass";
		case 5:
			return getEnumName ? "BuyPass" : "Buy Pass";
		default:
			return "Invalid";
	}
};

export const GetValueMiscFeeRadio = getValueMiscFeeRadio => {
	switch (+getValueMiscFeeRadio) {
		case 0:
			return "Per Item";
		case 1:
			return "Monthly";
		case 2:
			return "Annually";
		case 3:
			return "None";
		default:
			return "Invalid";
	}
};

export const MiscFeeMonth = miscFeeMonth => {
	switch (miscFeeMonth) {
		case "Jan":
			return "January";
		case "Feb":
			return "February";
		case "Mar":
			return "March";
		case "Apr":
			return "April";
		case "May":
			return "May";
		case "Jun":
			return "June";
		case "Jul":
			return "July";
		case "Aug":
			return "August";
		case "Sep":
			return "September";
		case "Oct":
			return "November";
		case "Nov":
			return "November";
		case "Dec":
			return "December";
		default:
			return "Invalid";
	}
};
